<template>
  <div>
    <!-- LOCALLY.COM WIDGET EMBED CODE -->
    <div
      id="lcly-button-0"
      data-switchlive="true"
      data-switchlive-impression="true"
      data-switchlive-impression-id-PL="1"
    >
      <a
        id="lcly-link-0"
        data-switchlive="true"
        data-switchlive-mode="auto"
        data-switchlive-id-PL="6"
        href="https://brands.locally.com"
        target="_blank"
      >
        Product Locator by Locally
      </a>
    </div>
    <component :is="'script'" ref="script" async />
  </div>
</template>

<script lang="ts" setup>
const props = defineProps<{
  styleId: string
}>()

const script = ref<HTMLScriptElement | null>(null)

onMounted(() => {
  const lcly_config_0: any = {
    company_name: 'EXPED',
    button_text: 'Find it Locally',
    button_id: 'HTML',
    company_id: '1381',
    color_0: '#999999',
    upc: props.styleId,
    n_related_styles: '3',
    show_location_switcher: '1',
    show_location_prompt: '1',
    lang: 'en-us',
    n_dealers: '3',
    no_link: '1',
  }
  const lcly_query_0 = Object.keys(lcly_config_0)
    .reduce(function (a: any, k: any) {
      a.push(encodeURIComponent(k) + '=' + encodeURIComponent(lcly_config_0[k]))
      return a
    }, [])
    .join('&')
  const lcly_endpoint_0 =
    'https://exped.locally.com/stores/map.js?' + lcly_query_0
  if (script.value) {
    script.value.src = lcly_endpoint_0
  }
})

watch(
  () => props.styleId,
  (upc) => {
    // @ts-ignore
    window.lcly_reload_0({ upc })
  },
)

onBeforeUnmount(() => {
  document.querySelector('#lcly-button-0')?.parentElement?.remove()
})
</script>

<style lang="postcss">
#lcly-link-0,
#lcly-location-prompt-0 {
  @apply hidden !important;
}
.lcly-primary-trigger {
  @apply font-bold uppercase text-sm tracking-normal align-baseline flex items-center hover:opacity-60;

  &:before {
    @apply pr-25 inline-block bg-no-repeat;

    content: '';
    width: 17px;
    height: 24px;
    background-image: url('~/assets/symbols/pin_mobile.svg');
    background-size: contain;
  }
}
</style>
